import React from 'react';
import { Smartphone, RefreshCw, Unlock, Layers, Wrench, Settings, MessageCircle, ChevronRight } from 'lucide-react';
import { services, businessInfo } from '../../data/mock';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '../ui/card';

const serviceIcons = {
  1: Smartphone,
  2: RefreshCw,
  3: Unlock,
  4: Layers,
  5: Wrench,
  6: Settings
};

export const ServicesSection = () => {
  return (
    <section id="layanan" className="relative bg-black py-24 lg:py-32">
      {/* Grid Pattern */}
      <div 
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `
            repeating-linear-gradient(0deg, transparent, transparent 1px, transparent 1px, transparent calc(100% / 13)),
            repeating-linear-gradient(90deg, #fff 0, #fff 1px, transparent 1px, transparent calc(100% / 13))
          `,
          backgroundSize: '100% 100%'
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-[#00FFD1] text-sm font-medium tracking-wider uppercase mb-4">
            Layanan Kami
          </span>
          <h2 className="text-white text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight mb-6">
            Solusi Lengkap untuk{' '}
            <span className="text-[#00FFD1]">Android Anda</span>
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            Kami menyediakan berbagai layanan profesional untuk mengatasi 
            segala masalah software Android Anda.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => {
            const Icon = serviceIcons[service.id];
            return (
              <Card 
                key={service.id}
                className="group bg-[#121212] border-white/10 hover:border-[#00FFD1]/30 transition-all duration-400 hover:-translate-y-1"
              >
                <CardHeader className="pb-4">
                  <div className="w-14 h-14 bg-[#00FFD1]/10 flex items-center justify-center mb-4 group-hover:bg-[#00FFD1]/20 transition-colors">
                    <Icon className="w-7 h-7 text-[#00FFD1]" />
                  </div>
                  <CardTitle className="text-white text-xl font-semibold mb-1">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-[#00FFD1]/80 text-sm">
                    {service.subtitle}
                  </CardDescription>
                </CardHeader>
                <CardContent className="pb-4">
                  <p className="text-white/60 text-base mb-4">
                    {service.description}
                  </p>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center gap-2 text-white/50 text-sm">
                        <div className="w-1.5 h-1.5 bg-[#00FFD1] rounded-full" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </CardContent>
                <CardFooter>
                  <a
                    href={`${businessInfo.whatsappLink}?text=Halo, saya tertarik dengan layanan ${service.title}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group/btn inline-flex items-center gap-2 text-[#00FFD1] text-sm font-medium hover:gap-3 transition-all"
                  >
                    <MessageCircle className="w-4 h-4" />
                    Chat via WhatsApp
                    <ChevronRight className="w-4 h-4" />
                  </a>
                </CardFooter>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
